/** Default stacking for review edit popovers on the normal page (above app chrome). */
export const REVIEW_EDIT_POPOVER_Z = 1500;
export const REVIEW_EDIT_MENU_Z = 1510;
export const REVIEW_EDIT_NESTED_DIALOG_Z = 1520;

/** Event stats dialog layer; edit UI must sit above it. */
export const REVIEW_STATS_DIALOG_Z = 1400;

export function reviewEditPopoverZ(anchorZ?: number): number {
  return (anchorZ ?? REVIEW_EDIT_POPOVER_Z) + 10;
}

export function reviewEditMenuZ(popoverZ: number): number {
  return popoverZ + 10;
}

export function reviewEditDialogZ(popoverZ: number): number {
  return popoverZ + 20;
}

export function reviewMenuZFromDialog(dialogZ: number): number {
  return dialogZ + 12;
}

/** Full-screen pro mode shell (ReviewProMode). */
export const PRO_MODE_Z_INDEX = 2000;
export const PRO_MODE_POPOVER_Z_INDEX = PRO_MODE_Z_INDEX + 1;
export const PRO_MODE_DIALOG_Z_INDEX = PRO_MODE_Z_INDEX + 2;
export const PRO_MODE_MENU_Z_INDEX = PRO_MODE_Z_INDEX + 30;
export const PRO_MODE_TOOLTIP_Z_INDEX = PRO_MODE_Z_INDEX + 40;
